const formatValue = (value) => (value ? Number(value).toLocaleString() : "-");

const mapRows = (rows = []) =>
  rows
    .filter((row) => row.grade !== "Campus Total")
    .map((row) => ({
      grade: row.grade,
      perumbakkam: row.perumbakkam,
      kvr: row.KVR,
      thiruvanmiyur: row.thiruvanmiyur,
      thirumudivakkam: row.thirumudivakkam,
      hyderabad: row.hyderbad,
      total: row.total,
    }));

const getTotals = (rows = []) => {
  const totalRow = rows.find((row) => row.grade === "Campus Total");

  return {
    perumbakkam: totalRow?.perumbakkam || 0,
    kvr: totalRow?.KVR || 0,
    thiruvanmiyur: totalRow?.thiruvanmiyur || 0,
    thirumudivakkam: totalRow?.thirumudivakkam || 0,
    hyderabad: totalRow?.hyderbad || 0,
    total: totalRow?.total || 0,
  };
};

const StudentStrengthTable = ({ data = [] }) => {
  const rows = mapRows(data);
  const totals = getTotals(data);

  return (
    <div className="overflow-hidden rounded-3xl bg-white shadow-sm">
      <div className="border-b border-slate-200 px-6 py-5">
        <h2 className="text-2xl font-bold text-indigo-950">
          Student Strength - Grade Wise
        </h2>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="border-b border-slate-200 text-left bg-slate-50/50">
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500">Grade</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 text-right">Perumbakkam</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 text-right">KVR</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 text-right">Thiruvanmiyur</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 text-right">Thirumudivakkam</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 text-right">Hyderabad</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 text-right">Total</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((row) => (
                <tr
                  key={row.grade}
                  className="border-b border-slate-100 transition-colors hover:bg-blue-50/50"
                >
                  <td className="px-4 py-3 text-sm font-medium text-slate-700">{row.grade}</td>
                  <td className="px-4 py-3 text-sm text-slate-600 text-right">{formatValue(row.perumbakkam)}</td>
                  <td className="px-4 py-3 text-sm text-slate-600 text-right">{formatValue(row.kvr)}</td>
                  <td className="px-4 py-3 text-sm text-slate-600 text-right">{formatValue(row.thiruvanmiyur)}</td>
                  <td className="px-4 py-3 text-sm text-slate-600 text-right">{formatValue(row.thirumudivakkam)}</td>
                  <td className="px-4 py-3 text-sm text-slate-600 text-right">{formatValue(row.hyderabad)}</td>
                  <td className="px-4 py-3 text-sm font-semibold text-slate-700 text-right">
                    {formatValue(row.total)}
                  </td>
                </tr>
            ))}
          </tbody>

          <tfoot>
            <tr className="bg-blue-600 text-white">
              <td className="px-4 py-3 text-sm font-bold uppercase tracking-wider">Campus Total</td>
              <td className="px-4 py-3 text-sm font-bold text-right">{formatValue(totals.perumbakkam)}</td>
              <td className="px-4 py-3 text-sm font-bold text-right">{formatValue(totals.kvr)}</td>
              <td className="px-4 py-3 text-sm font-bold text-right">{formatValue(totals.thiruvanmiyur)}</td>
              <td className="px-4 py-3 text-sm font-bold text-right">{formatValue(totals.thirumudivakkam)}</td>
              <td className="px-4 py-3 text-sm font-bold text-right">{formatValue(totals.hyderabad)}</td>
              <td className="px-4 py-3 text-sm font-bold text-right">{formatValue(totals.total)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default StudentStrengthTable;
